import i18n from '@/utils/i18n'

export function notificationRoleLabel(role: string): string {
  const key = `notif.role.${role}`
  const label = i18n.t(key)
  return label === key ? role : label
}

export const NOTIFICATION_ROLES = [
  'admin',
  'dispatcher',
  'manager',
  'customer_supervisor',
  'inspector',
  'contractor_supervisor',
] as const

export type NotificationRole = (typeof NOTIFICATION_ROLES)[number]
